import { siteConfig } from "@/config/site";
import type { Service } from "@/types/content";

export function formatPrice(value: number): string {
  const formatted = new Intl.NumberFormat("es-MX").format(value);
  return `${siteConfig.currencySymbol}${formatted}`;
}

export function formatServicePrice(service: Pick<Service, "price" | "priceFrom" | "priceLabel">): string {
  if (service.priceLabel) {
    return service.priceLabel;
  }

  if (typeof service.price === "number") {
    return `${service.priceFrom ? "Desde " : ""}${formatPrice(service.price)}`;
  }

  return "Consultar";
}

export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  return new Intl.DateTimeFormat("es-MX", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}
